//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Reflux from 'reflux'
import BankStore from '../../store/bankstore'
import utils from '../../helpers/bankHelper'

class HeaderSteps extends Reflux.Component {

    constructor(props) {
        super()
        this.state = {
            currentStep: props.currentStep,
            nextStep: null
        }
        this.store = BankStore
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            currentStep: nextProps.currentStep
        });
    }

    prevStep = step => {
        if (this.state.currentStep <= step) return
        if (step <= 3) {
            utils.removeSavedPairedItems()
        }
        this.props.prevStep(step)
    }

    render() {
        return (
            <div className="steps-container">
                <div className="container">
                    <div className="row ">
                        <ul className="breadcrumb">
                            <li onClick={(step) => this.prevStep(1)}><a className='visited'>1. Feltöltés</a></li>
                            <li onClick={(step) => this.prevStep(2)}><a className={this.state.currentStep > 1 ? 'visited' : ''}>2. Kontírozás</a></li>
                            <li onClick={(step) => this.prevStep(3)}><a className={this.state.currentStep > 2 ? 'visited' : ''}>3. Párosítás</a></li>
                            <li><a className={this.state.currentStep > 3 ? 'visited' : ''}>4. Letöltés</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderSteps


// WEBPACK FOOTER //
// ./src/components/bank/headersteps.js